/**
 * Appointment Completed - Automated Messages Settings
 * Configure the Google review request texted after a client checks out, and its one reminder.
 */

import { createFileRoute, useParams } from '@tanstack/react-router'
import { Helmet } from 'react-helmet-async'
import { SettingsPageHeader } from '@/components/ui'
import { BusinessSetupPageShell } from './business-setup/components/business-setup-page-shell'
import { AppointmentCompletedTimeline } from './automated-messages/components/appointment-completed-timeline'
import { formatDocumentTitle } from '@/lib/document-title'
import { salonReviewsAfterCheckout, salonVisitsKnownByTap } from '@/features/salon-setup/salon-setup-page-meanings'
import { reviewRequestPageName } from '@/features/marketing/reviews/review-request-page-name'
import { useSalonSetup } from '@/hooks/use-salon-setup'

export const Route = createFileRoute('/_auth/$orgId/settings/automated-messages/appointment-completed')({
  component: AppointmentCompletedPage,
})

function AppointmentCompletedPage() {
  const { orgId } = useParams({
    from: '/_auth/$orgId/settings/automated-messages/appointment-completed',
  })
  // No check-in and no Hayven checkout: Hayven Tap tells Hayven who came (the timeline explains what sends the request).
  const setupState = useSalonSetup()
  const visitsKnownByTap = salonVisitsKnownByTap(setupState)
  const pageName = reviewRequestPageName(setupState)

  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle(pageName, 'Automated Messages')}</title>
      </Helmet>

      <BusinessSetupPageShell orgId={orgId} activePath="appointment-completed">
        <SettingsPageHeader
          title={pageName}
          description={
            visitsKnownByTap
              ? 'Ask happy clients for a Google review after their visit.'
              : salonReviewsAfterCheckout(setupState)
                ? 'Messages sent after a client checks out. Use this to ask happy clients for a Google review.'
                : 'Messages sent after each visit marked Done. Use this to ask happy clients for a Google review.'
          }
        />

        <div className="max-w-3xl">
          <AppointmentCompletedTimeline />
        </div>
      </BusinessSetupPageShell>
    </>
  )
}
